<template>
  <template v-if="version === 'v1' && !sidebarComponents && isVertical">
    <div
      class="property-list-item tw-group tw-relative tw-mt-1 tw-flex tw-flex-col tw-px-5 tw-py-6 tw-text-start md:tw-min-h-[700px] md:tw-p-6"
      style="border-radius: var(--rounded)"
    >
      <div class="tw-relative">
        <LibraryImage
          :src="property.image"
          :h-ratio="10"
          :w-ratio="16"
          image-class="card-img tw-overflow-hidden"
          style="border-radius: var(--rounded)"
          :blur="imageBlurFilter"
          :pre-market-blur-text="preMarketBlurText"
        />
        <div
          v-if="property.custom_property_status_title"
          :class="[
            'tw-absolute tw-flex tw-items-center tw-justify-center tw-bg-black/50',
            property.is_locked ? 'tw-bottom-0 tw-left-0 tw-right-0' : 'tw-inset-0',
          ]"
        >
          <div class="tw-text-3xl tw-font-bold tw-text-white">
            {{ property.custom_property_status_title }}
          </div>
        </div>
      </div>

      <template v-if="!property.is_locked">
        <div class="tw-mt-6 tw-flex tw-flex-col">
          <h5 class="tw-mb-2" style="color: var(--c-text_secondary)">
            {{ property.price.type?.name || '\u00A0' }}
          </h5>
          <h3 style="color: var(--c-primary) !important">{{ property.price.price }}</h3>
        </div>
      </template>
      <template v-else-if="property.is_locked">
        <div class="tw-mt-6 tw-flex tw-flex-col">
          <h5>{{ preMarketBlurText || 'Pre-market Property' }}</h5>
        </div>
      </template>

      <div class="tw-mt-5 tw-border-b-2 tw-pb-3">
        <h4 class="n-title-primary tw-line-clamp-3 tw-max-h-[94px] tw-min-h-[94px] group-hover:tw-underline">
          {{ property.advert_heading }}
        </h4>
      </div>

      <div class="tw-mt-5 tw-line-clamp-2 tw-flex tw-h-20 tw-flex-col tw-items-start tw-gap-2">
        <h5>Address:</h5>
        <p style="color: var(--c-text_primary) !important">{{ property.display_address }}</p>
      </div>

      <template v-if="!property.is_locked">
        <div class="tw-mt-6 tw-flex tw-min-h-[32px] tw-flex-wrap tw-gap-x-6 tw-gap-y-3">
          <div v-if="property.bedroom">
            <h5>Bedrooms</h5>
            <h3>{{ property.bedroom }}</h3>
          </div>
          <div v-if="property.bathroom">
            <h5>Bathrooms</h5>
            <h3>{{ property.bathroom }}</h3>
          </div>
          <div v-if="property.reception">
            <h5>Receptions</h5>
            <h3>{{ property.reception }}</h3>
          </div>
        </div>

        <button class="n-primary tw-mt-8 tw-self-start">VIEW THIS PROPERTY</button>
      </template>

      <template v-else-if="property.is_locked">
        <p class="tw-py-2">
          This is a pre-market property. You need to create an account and register to our property alerts in order to
          view it.
        </p>
        <div class="tw-mt-10 tw-flex tw-gap-x-2">
          <nuxt-link :to="routes.REGISTER" class="n-primary tw-w-fit" :external="true">Register</nuxt-link>
          <nuxt-link
            :to="`${routes.PROPERTY_DETAIL.replace(':propertyId', property.property_profile_id)}#login`"
            class="n-primary tw-w-fit"
            :external="true"
            >Login</nuxt-link
          >
        </div>
      </template>
    </div>
  </template>

  <template v-if="version === 'v1' && !sidebarComponents && !isVertical">
    <div
      class="property-list-item tw-group tw-relative tw-mt-1 tw-flex tw-flex-col tw-items-center tw-px-5 tw-py-6 tw-text-start md:tw-min-h-[700px] md:tw-p-6 lg:tw-min-h-full lg:tw-flex-row lg:tw-gap-10"
      style="border-radius: var(--rounded)"
    >
      <div class="tw-relative tw-w-full">
        <LibraryImage
          :src="property.image"
          :h-ratio="10"
          :w-ratio="16"
          image-class="card-img tw-overflow-hidden"
          style="border-radius: var(--rounded)"
          :blur="imageBlurFilter"
          :pre-market-blur-text="preMarketBlurText"
        />
        <div
          v-if="property.custom_property_status_title"
          :class="[
            'tw-absolute tw-flex tw-items-center tw-justify-center tw-bg-black/50',
            property.is_locked ? 'tw-bottom-0 tw-left-0 tw-right-0' : 'tw-inset-0',
          ]"
        >
          <div class="tw-text-3xl tw-font-bold tw-text-white">
            {{ property.custom_property_status_title }}
          </div>
        </div>
      </div>

      <div class="tw-flex tw-w-full tw-flex-col lg:tw-pl-6">
        <template v-if="!property.is_locked">
          <div class="tw-mt-6 tw-flex tw-flex-col">
            <h5 class="tw-mb-2" style="color: var(--c-text_secondary)">
              {{ property.price.type?.name || '\u00A0' }}
            </h5>
            <h3 style="color: var(--c-primary) !important">{{ property.price.price }}</h3>
          </div>
        </template>
        <template v-else-if="property.is_locked">
          <div class="tw-mt-6 tw-flex tw-flex-col">
            <h5>{{ preMarketBlurText || 'Pre-market Property' }}</h5>
          </div>
        </template>
        <div class="tw-mt-5 tw-border-b-2 tw-pb-3">
          <h4 class="n-title-primary tw-line-clamp-3 tw-max-h-[94px] tw-min-h-[94px] group-hover:tw-underline">
            {{ property.advert_heading }}
          </h4>
        </div>
        <div class="tw-mt-5 tw-line-clamp-2 tw-flex tw-h-20 tw-flex-col tw-items-start tw-gap-2">
          <h5>Address:</h5>
          <p style="color: var(--c-text_primary) !important">{{ property.display_address }}</p>
        </div>
        <template v-if="!property.is_locked">
          <div class="tw-mt-6 tw-flex tw-min-h-[32px] tw-flex-wrap tw-gap-x-6 tw-gap-y-3">
            <div v-if="property.bedroom">
              <h5>Bedrooms</h5>
              <h3>{{ property.bedroom }}</h3>
            </div>
            <div v-if="property.bathroom">
              <h5>Bathrooms</h5>
              <h3>{{ property.bathroom }}</h3>
            </div>
            <div v-if="property.reception">
              <h5>Receptions</h5>
              <h3>{{ property.reception }}</h3>
            </div>
          </div>
          <button class="n-primary tw-mt-8 tw-self-start">VIEW THIS PROPERTY</button>
        </template>
        <template v-else-if="property.is_locked">
          <p class="tw-py-2">
            This is a pre-market property. You need to create an account and register to our property alerts in order to
            view it.
          </p>
          <div class="tw-mt-10 tw-flex tw-gap-x-2">
            <nuxt-link :to="routes.REGISTER" class="n-primary tw-w-fit" :external="true">Register</nuxt-link>
            <nuxt-link
              :to="`${routes.PROPERTY_DETAIL.replace(':propertyId', property.property_profile_id)}#login`"
              class="n-primary tw-w-fit"
              :external="true"
              >Login</nuxt-link
            >
          </div>
        </template>
      </div>
    </div>
  </template>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { PropertyItemComponent } from '~/units/properties/types';
import NcTooltip from '~/components/common/NcTooltip.vue';
import { PropertyMixin } from '~/units/properties/mixins/property.mixin';

export default defineNuxtComponent({
  name: 'Theme9PropertyListItem',

  mixins: [PropertyMixin],

  components: { NcTooltip },

  props: {
    property: {
      required: true,
      type: Object as PropType<PropertyItemComponent>,
    },

    isMatchInformationHidden: {
      required: false,
      type: Boolean,
      default: false,
    },

    isVertical: {
      required: false,
      type: Boolean,
      default: true,
    },

    version: {
      required: false,
      type: String,
      default: 'v1',
    },

    preMarketPropertyFeature: {
      required: false,
      type: Boolean,
      default: false,
    },

    colSpan: {
      required: false,
      type: Number,
      default: 4,
    },

    isLetterPropertyCriteria: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style>
.property-item {
  text-decoration: none;
}

.property-item:hover {
  text-decoration: none;
}
</style>
